import { inject, Injectable } from '@angular/core';
import { PlatformService } from '@shared/services/platform-service.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationPermissionService {
  private readonly platformService = inject(PlatformService);

  promptIfNeeded() {
    return this.platformService.run({
      browser: () => {
        try {
          if (!('Notification' in window)) return undefined;
          const alreadyPrompted =
            localStorage.getItem('notif_prompted') === '1';
          if (alreadyPrompted) return undefined;
          if (Notification.permission !== 'default') return undefined;

          // const ref = this.modalUtils.openModal(
          //   NotificationPermissionDialogComponent,
          //   {
          //     backdrop: 'static',
          //     keyboard: false,
          //   }
          // );

          // No need to handle result; dialog will persist the flag
          // return ref;
          return undefined;
        } catch {
          return undefined;
        }
      },
      server: () => undefined,
    });
  }
}
